var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube02 = function SvgYoutube02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "youtube_02_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 144 144"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".youtube_02_svg__st0{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 56.8v32l13.8-8 14-8-13.9-8z",
    className: "youtube_02_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72 0C32.2 0 0 32.2 0 72s32.2 72 72 72 72-32.2 72-72S111.8 0 72 0m45 87.1c0 9.5-7.7 17.1-17.1 17.2H44.2c-9.5 0-17.1-7.7-17.2-17.2V56.9c0-9.5 7.7-17.1 17.2-17.1h55.7c9.5 0 17.1 7.7 17.2 17.1v30.2z",
    className: "youtube_02_svg__st0"
  })));
};
export default SvgYoutube02;